<div class="section-header d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
  <h5 class="mb-0 fw-bold">Pagos</h5>
</div>

<div *ngIf="!locationId" class="info-box m-3">
  <mat-icon>info</mat-icon>
  <span>Guarda los datos generales del centro de trabajo para poder configurar los pagos.</span>
</div>

<div *ngIf="locationId" class="payments-section container-fluid py-3">

  <!-- ========== Stripe block ========== -->

  <h6 class="fw-bold mb-3">Pasarela de pago</h6>

  <div *ngIf="isLoading" class="text-center py-4">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    <p class="text-muted">Cargando estado de Stripe…</p>
  </div>

  <div *ngIf="!isLoading">
    <!-- 1. Not connected -->
    <div *ngIf="!isConnected" class="payments-card">
      <div class="payments-card__head">
        <mat-icon class="text-muted">link</mat-icon>
        <strong>Stripe no está conectado</strong>
      </div>
      <p class="text-muted mb-3">
        Conecta tu cuenta de Stripe para aceptar pagos online en este centro.
        Te llevaremos a Stripe para completar la verificación (KYC) y volverás aquí cuando termines.
      </p>
      <app-button
        label="Conectar con Stripe"
        icon="link"
        variant="primary"
        [loading]="isProcessing"
        (click)="connectStripe()">
      </app-button>
    </div>

    <!-- 2. Pending / restricted -->
    <div *ngIf="isConnected && isPending" class="payments-card payments-card--pending">
      <div class="payments-card__head">
        <mat-icon class="payments-card__icon--pending">warning</mat-icon>
        <strong>Cuenta de Stripe pendiente de verificación</strong>
      </div>
      <p class="text-muted mb-2">
        Has iniciado la conexión con Stripe pero todavía falta información para activar los cobros.
        Continúa con el onboarding para completarlo.
      </p>
      <p *ngIf="status?.externalAccountId" class="text-muted small mb-3">
        Cuenta: <code>{{ status?.externalAccountId }}</code>
      </p>
      <div class="payments-card__actions">
        <app-button
          label="Continuar onboarding"
          icon="arrow_forward"
          variant="primary"
          [loading]="isProcessing"
          (click)="connectStripe()">
        </app-button>
        <app-button
          label="Desconectar"
          icon="link_off"
          variant="text"
          [disabled]="isProcessing"
          (click)="disconnect()">
        </app-button>
      </div>
    </div>

    <!-- 3. Active -->
    <div *ngIf="isConnected && isActive" class="payments-card payments-card--active">
      <div class="payments-card__head">
        <mat-icon class="payments-card__icon--active">check_circle</mat-icon>
        <strong>Stripe conectado</strong>
      </div>
      <p *ngIf="status?.externalAccountId" class="text-muted small mb-2">
        Cuenta: <code>{{ status?.externalAccountId }}</code>
      </p>
      <ul class="payments-card__bullets">
        <li>
          <mat-icon class="payments-card__icon--ok">done</mat-icon>
          Cobros habilitados
        </li>
        <li>
          <mat-icon
            [class.payments-card__icon--ok]="status?.payoutsEnabled"
            [class.payments-card__icon--pending]="!status?.payoutsEnabled">
            {{ status?.payoutsEnabled ? 'done' : 'schedule' }}
          </mat-icon>
          {{ status?.payoutsEnabled ? 'Payouts habilitados' : 'Payouts pendientes' }}
        </li>
      </ul>
      <div class="payments-card__actions">
        <app-button
          label="Ver dashboard Stripe"
          icon="open_in_new"
          variant="secondary"
          [loading]="isProcessing"
          (click)="openDashboard()">
        </app-button>
        <app-button
          label="Desconectar"
          icon="link_off"
          variant="text"
          [disabled]="isProcessing"
          (click)="disconnect()">
        </app-button>
      </div>
    </div>
  </div>

  <!-- ========== Policy block ========== -->

  <hr class="my-4">

  <h6 class="fw-bold mb-3">Política de pagos</h6>

  <div *ngIf="isLoadingPolicy" class="text-center py-4">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    <p class="text-muted small">Cargando política…</p>
  </div>

  <form *ngIf="!isLoadingPolicy" [formGroup]="policyForm" class="payments-card">
    <div class="policy-toggle">
      <mat-checkbox formControlName="acceptOnlinePayment" [disabled]="!canEnableOnline">
        Aceptar pago online
      </mat-checkbox>
      <small *ngIf="!canEnableOnline" class="text-muted ms-2">
        (conecta Stripe para activar)
      </small>
    </div>

    <div class="policy-toggle">
      <mat-checkbox
        formControlName="onlinePaymentRequired"
        [disabled]="!policyForm.get('acceptOnlinePayment')?.value">
        Exigir pago online obligatorio al reservar
      </mat-checkbox>
    </div>

    <div class="policy-toggle">
      <mat-checkbox formControlName="acceptCashPayment">
        Aceptar pago en el local (efectivo)
      </mat-checkbox>
    </div>

    <mat-form-field appearance="outline" class="w-100 mt-3">
      <mat-label>Política de cancelación (se mostrará al cliente)</mat-label>
      <textarea
        matInput
        formControlName="cancellationPolicy"
        rows="4"
        maxlength="2000"
        placeholder="Ej.: cancelaciones gratuitas hasta 24h antes; menos de 24h se cobra el 50%."></textarea>
      <mat-hint align="end">
        {{ (policyForm.get('cancellationPolicy')?.value?.length || 0) }} / 2000
      </mat-hint>
    </mat-form-field>

    <div class="payments-card__actions mt-3">
      <app-button
        label="Guardar política"
        icon="save"
        variant="primary"
        [loading]="isSavingPolicy"
        [disabled]="policyForm.invalid"
        (click)="savePolicy()">
      </app-button>
    </div>
  </form>
</div>
